/**
 * Component to handle all the things connected to streaming
 * @module app/components/Streaming
 */
import _ from 'lodash';
import jQuery from 'jquery';
import login from '../../app/components/Login';
import raceButtonTemplate from '../views/templates/RaceButton';

/**
 * Default sport to ask available streamings for.
 *
 * @type {String}
 */
var defaultSportName = 'horse-racing';

/**
 * Holds references to created players
 *
 * @type {Array<Object>}
 */
let players = [];

/**
 * Compile and update the HTML for My WHTV Races
 *
 * @param {Array} myWhtvRaces Array containing user-qualified races
 *
 * @returns {void}
 *
 * @private
 */
var updateMyWhtvRaces = function updateMyWhtvRaces(myWhtvRaces) {

    var myWhtvRacesContainer = jQuery('.myWhtvRaces');
    var myWhtvRacesTemplate = '';

    if (myWhtvRacesContainer && _.size(myWhtvRaces)) {

        hideMyWhtvMessages();

        _.each(myWhtvRaces, function (singleRace) {

            myWhtvRacesTemplate += _.template(raceButtonTemplate)({ data: singleRace });
        });
    }

    myWhtvRacesContainer.find('.race-meeting__nav').html(myWhtvRacesTemplate);
};

/**
 * Hides My WHTV Races messages for logged in users with some races qualified for streaming
 *
 * @returns {void}
 *
 * @private
 */
var hideMyWhtvMessages = function hideMyWhtvMessages() {

    var header = jQuery('.myWhtvRaces .race-meeting__header');

    if (header.length) {

        header.find('.alert-info').addClass('displayNone');
        header.find('.message-notification').addClass('displayNone');
    }
};

/**
 * Updates My WHTV message for logged in users
 *
 * @returns {void}
 *
 * @private
 */
var updateMyWhtvRacesMessage = function updateMyWhtvRacesMessage() {

    var header = jQuery('.myWhtvRaces .race-meeting__header');

    if (header.length) {

        header.find('.alert-info').addClass('displayNone');
        header.find('.message-notification').removeClass('displayNone');
    }
};

/**
 * Updates buttons in Meetings Nav
 *
 * @param {Array} myWhtvRaces Array with qualified buttons
 * @param {String} eventId Event ID
 *
 * @returns {Array}
 *
 * @private
 */
var updateMeetingNavigationButtons = function updateMeetingNavigationButtons(myWhtvRaces, eventId) {

    var raceButton =
        jQuery('.tabs_nav--container .race-meeting__selection[data-entityid="' + eventId + '"]');

    if (raceButton.length && raceButton.attr('data-settled') !== 'true') {

        raceButton.addClass('race-meeting__selection--qualified');
        myWhtvRaces.push({
            'id': eventId,
            'name': raceButton.attr('data-racename'),
            'date': raceButton.attr('data-startdatetime'),
        });
    }

    return myWhtvRaces;
};

var updateNextOffMeetingsButtons = function updateNextOffMeetingsButtons(eventId) {

    var raceButton = jQuery('.next-off-list .next-off-list__btn[data-entityid="' + eventId + '"]');

    if (raceButton.length && raceButton.attr('data-settled') !== 'true') {
        raceButton.addClass('next-off-list__btn--streaming');
        raceButton.find('.icon__qualified-race')
            .removeClass('displayNone');
    }
};

var updateRaceToRaceNavigationButtons = function updateRaceToRaceNavigationButtons(eventId) {
    var raceButton = jQuery('.races-buttons-list__button[data-entityid="' + eventId + '"]');

    if (raceButton.length && raceButton.attr('data-settled') !== 'true') {
        raceButton.addClass('races-buttons-list__button--streaming');
        raceButton.find('.icon__qualified-race').removeClass('displayNone');
    }
};

/**
 * Updates WHTV icon in Meeting Nav
 *
 * @returns {void}
 *
 * @private
 */
var updateWhtvIcon = function updateWhtvIcon() {

    jQuery('#asideMeetingsNavigation .race-meeting__selection[data-streamingAvailable="true"]')
        .parents('.race-meeting')
        .find('.race-meeting__media-item--yellow')
        .parent()
        .removeClass('displayNone');

    jQuery('#asideMeetingsNavigation .race-meeting__media[data-streamingAvailable="true"]')
        .parents('.race-subnav__group-header')
        .find('.bet-tv')
        .parent()
        .removeClass('displayNone');

};

/**
 * Simple callback runner with a check
 *
 * @param {Function} callback
 *
 * @returns {void}
 *
 * @private
 */
var runCallback = function runCallback(callback) {

    if (typeof callback === 'function') {

        callback();
    }
};

/**
 * This function helps us to initialize the streaming player
 *
 * @params  {Object}    streamContainer jQuery object streaming container
 *
 * @returns void
 *
 * @private
 */
var initializeStreamingContainer = function initializeStreamingContainer(streamContainer, eventId) {

    streamContainer.find('.raceEventMessages').addClass('displayNone');
    jQuery('[id="' + eventId + '"]').find('.openStream').off('click.openStream');
    initializeStreamPlayer(streamContainer);
    setupToggleStreamingPlayer(streamContainer);
};

/**
 * Destroys all players created so far.
 *
 * @returns {void}
 *
 * @public
 */
const reset = () => {

    players.forEach(p => p.destroy());
    players = [];
};

/**
 * Initialize all the streaming icons on the page. For that we call SAS
 * (streaming auth service) for list of eventIds user is qualified to view
 * streaming for.
 *
 * @param {Function} callback Optional callback
 *
 * @returns {void}
 *
 * @private
 */
var initializeStreaming = function initializeStreaming(callback) {

    /**
     * Done function for SAS getJSON.
     *
     * @param {Object} json  JSON coming from the ajax request.
     *
     * @returns {void}
     *
     * @private
     */
    var onDone = function onDone(json) {

        var myWhtvRaces = [];

        /**
         * Function to update each race in menu and initialize the streaming
         *
         * @param {String} eventId   race ID.
         *
         * @returns {void}
         *
         * @private
         */
        var updateSingleRace = function updateSingleRace(eventId) {
            myWhtvRaces = updateMeetingNavigationButtons(myWhtvRaces, eventId);
            updateNextOffMeetingsButtons(eventId);
            updateRaceToRaceNavigationButtons(eventId);

            jQuery('.race-header__toolbar-item[data-entityid="' + eventId + '"]')
                .addClass('race-header__toolbar-item--tv').removeClass('noClick');

            jQuery('#' + eventId + ' .notQualified').addClass('displayNone');
            jQuery('#' + eventId + ' .race-event__view-message--qualified')
                .removeClass('displayNone');

            jQuery('[id="' + eventId + '"]')
                .find('.openStream')
                .off('click.openStream')
                .on('click.openStream', function () {

                    if (jQuery(this).hasClass('noClick') === false) {

                        initializeStreamingContainer(
                            jQuery(this).parents('.race-event__header'), eventId
                        );
                    }

                    return false;
                });
        };

        if (json && Array.isArray(json) && _.size(json)) {

            _.each(json, updateSingleRace);
            updateMyWhtvRaces(_.sortBy(myWhtvRaces, 'date'));
            runCallback(callback);
        } else {

            updateMyWhtvRacesMessage();
        }
    };

    /**
     * Builds the SAS url to get the list of eventIds user is qualified to
     * view streams for.
     *
     * @returns {String} SAS url.
     *
     * @private
     */
    var buildSasUrl = function buildSasUrl () {

        /**
         * Returns the sportEn sport expected by SAS, or defaultSportName
         * if not defined.
         *
         * @returns {String} current sport.
         *
         * @private
         */
        var getSportName = function getSportName () {

            if (window.WH && window.WH.sportsbook && window.WH.sportsbook.sportEn) {

                return window.WH.sportsbook.sportEn.toString();
            }

            return defaultSportName;
        };

        /**
         * Formats given input Date to be used in SAS request.
         *
         * @param {Object} date  js Date object to format for SAS call.
         *
         * @returns {String} ISO8601 date (eg '2017-01-30'); UTC.
         *
         * @private
         */
        var formatDate = function formatDate (date) {

            return date.toISOString().slice(0, 10);
        };

        var date = new Date();
        var dateFrom = formatDate(date);
        date.setDate(date.getDate() + 1);  // prepare for dateTo url param

        return window.whStatic.config.streaming.streamBaseURL + '/api/streams/events' +
                '?responseFormat=IDS&geoValidationOnly=false' +
                '&type=LIVE&permitted=true&sport=' + getSportName() +
                '&dateFrom=' + dateFrom + '&dateTo=' + formatDate(date);
    };

    // AJAX call to SAS (streaming authorization service)
    jQuery.ajax({
        url: buildSasUrl(),
        xhrFields: {
            withCredentials: true,
        },
        headers:{ 'Accept': '*/*' },
        crossDomain: true,
    }).done(onDone).fail(updateMyWhtvRacesMessage);
};

/**
 * This function will setup the open/close functionality when the video has been initialized.
 *
 * @param   {Object}    streamContainer jQuery Object with the stream section
 *
 * @returns {void}
 *
 * @private
 */
var setupToggleStreamingPlayer = function setupToggleStreamingPlayer(streamContainer) {

    /**
     * This function close the streaming section
     *
     * @returns {void}
     *
     * @private
     */
    var closeStreaming = function closeStreaming() {

        streamContainer.find('.cpt-streaming__video').addClass('displayNone');
        iconContainer.removeClass('icon-streaming-close').addClass('icon-tv');
        streamContainer.find('.raceEventMessages').removeClass('displayNone');
    };

    /**
     * This function open the streaming section
     *
     * @returns {void}
     *
     * @private
     */
    var openStreaming = function openStreaming() {

        streamContainer.find('.cpt-streaming__video').removeClass('displayNone');
        iconContainer.removeClass('icon-tv').addClass('icon-streaming-close');
        streamContainer.find('.raceEventMessages').addClass('displayNone');
    };

    var iconContainer = streamContainer.find('.icon-tv');
    iconContainer.removeClass('icon-tv').addClass('icon-streaming-close');
    iconContainer.parent().off('click.toggleStream').on('click.toggleStream', function () {

        if (jQuery(this).find('.icon-streaming-close').length > 0) {

            closeStreaming();
            return;
        }

        openStreaming();
    });

    //Listener for opening when messageContainer is clicked
    streamContainer.find('.raceEventMessages').off('click.toggleStream').on('click.toggleStream', openStreaming);
};

/**
 * Initializes given stream player
 *
 * @param {Object} raceEventHeader Race event header containing the stream
 *
 * @returns {void}
 *
 * @private
 */
var initializeStreamPlayer = function initializeStreamPlayer(raceEventHeader) {
    const streamPlayer = raceEventHeader.find('.streamPlayer');
    const streamEntityId = streamPlayer.attr('data-entityid').replace('OB_EV', '');

    players.push(
        new window.WH.StreamPlayer({
            eventId: streamEntityId,
            container: 'HRStreamContainer',
            locale: window.WH.sportsbook.lang.toLowerCase(),
            backendUrl: window.whStatic.config.streaming.streamBaseURL,
            self: 'TRAF_RACECARD',
            streamType: 'LIVE',
        })
    );

    raceEventHeader.find('.cpt-streaming__video').removeClass('displayNone');
};

/**
 * Change user message for logged in user
 *
 * @returns {void}
 *
 * @private
 */
const changeUserMessageAfterLogin = () => {
    jQuery('.notLoggedIn').addClass('displayNone');
    jQuery('.notQualified').removeClass('displayNone');
};

/**
 * Public functions.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Tries to get user logged in state and initialize the streaming
     *
     * @param {Function} callback Optional callback
     *
     * @returns {void}
     *
     * @public
     */
    init: function init(callback) {

        updateWhtvIcon();
        if (login.isLoggedIn()) {
            changeUserMessageAfterLogin();
            initializeStreaming(callback);
        }
    },

    reset,
};

export default api;
